import React from 'react';
import { Home, Building, Warehouse, CheckCircle2 } from 'lucide-react';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
import { AnimateOnScroll } from './AnimateOnScroll';
export function ServicesSection() {
  const services = [{
    icon: <Home className="h-10 w-10 text-primary" data-id="element-314" />,
    title: 'Residential Management',
    description: 'Full-service management for single-family homes, apartments, and multi-unit properties.',
    features: ['Tenant Screening', 'Rent Collection', 'Maintenance Coordination', '24/7 Emergency Support'],
    isPopular: true,
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=800&q=80'
  }, {
    icon: <Building className="h-10 w-10 text-primary" data-id="element-315" />,
    title: 'HOA Management',
    description: 'Comprehensive homeowner association management including financial reporting and vendor coordination.',
    features: ['Financial Reporting', 'Vendor Management', 'Community Communications', 'Board Support'],
    isPopular: false,
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=800&q=80'
  }, {
    icon: <Warehouse className="h-10 w-10 text-primary" data-id="element-316" />,
    title: 'Commercial Properties',
    description: 'Professional management for retail, office, and industrial properties focused on maximizing returns.',
    features: ['Lease Administration', 'Occupancy Optimization', 'Property Marketing', 'Financial Analysis'],
    isPopular: false,
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80'
  }];
  return <section className="py-24 bg-muted/30" data-id="element-317">
      <div className="container mx-auto px-4" data-id="element-318">
        <AnimateOnScroll data-id="element-319">
          <div className="text-center mb-16" data-id="element-320">
            <p className="text-[oklch(0.45_0.16_250)] font-medium text-sm uppercase tracking-widest mb-3" data-id="element-321">
              Our Expertise
            </p>
            <h2 className="font-heading text-3xl md:text-4xl font-medium text-foreground mb-4" data-id="element-322">
              Management Services
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto" data-id="element-323">
              Tailored solutions designed to protect your investment and
              maximize your returns.
            </p>
          </div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-14" data-id="element-324">
          {services.map((service, index) => <AnimateOnScroll key={index} delay={index * 0.12} data-id="element-325">
              <div className={`group bg-white rounded-2xl overflow-hidden h-full flex flex-col hover:shadow-xl transition-all duration-300 ${service.isPopular ? 'ring-2 ring-primary shadow-lg' : 'border border-border/60'}`} data-id="element-326">
                <div className="relative h-52 overflow-hidden" data-id="element-327">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-328" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-329" />
                  {service.isPopular && <Badge className="absolute top-4 right-4 bg-[oklch(0.45_0.16_250)] text-white border-0 font-medium shadow-md px-3 py-1" data-id="element-330">
                      Most Popular
                    </Badge>}
                </div>
                <div className="p-6 flex-1 flex flex-col" data-id="element-331">
                  <div className="flex items-center gap-3 mb-3" data-id="element-332">
                    {service.icon}
                    <h3 className="font-heading text-xl font-medium text-foreground" data-id="element-333">
                      {service.title}
                    </h3>
                  </div>
                  <p className="text-muted-foreground text-sm leading-relaxed mb-5" data-id="element-334">
                    {service.description}
                  </p>
                  <ul className="space-y-2.5 mt-auto" data-id="element-335">
                    {service.features.map((feature, i) => <li key={i} className="flex items-center gap-2.5 text-sm text-foreground" data-id="element-336">
                        <CheckCircle2 className="h-4 w-4 text-primary shrink-0" data-id="element-337" />
                        {feature}
                      </li>)}
                  </ul>
                </div>
              </div>
            </AnimateOnScroll>)}
        </div>

        <AnimateOnScroll delay={0.2} data-id="element-338">
          <div className="flex justify-center" data-id="element-339">
            <Button className="px-10 py-5 h-auto text-lg font-medium shadow-lg rounded-xl" data-id="element-340">
              Get a Free Consultation
            </Button>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}